import { Flex } from "@chakra-ui/react";
import { PageFrame } from "components/frames/PageFrame";
import { CardSkeleton, ShimmerInPhase } from "components/ui/skeleton";

/**
 * The skeleton of the branch overview: the banner, then the details card.
 *
 * The router shows it while the branch route chunks load, and the page shows
 * it while the branch loads. Thus a cold load shows one skeleton from start to
 * end. `router.tsx` imports this file statically, so keep it free of the page
 * code.
 */
export const BranchOverviewSkeleton = () => (
  <ShimmerInPhase>
    <PageFrame aria-busy="true" data-cy="branch-overview-skeleton">
      <Flex direction="column" gap="6">
        <CardSkeleton lines={1} />
        <CardSkeleton lines={3} headerAction />
      </Flex>
    </PageFrame>
  </ShimmerInPhase>
);
